/**
 * The heat-pump drawing family — the ids `HeatPumpAnimation.vue` draws.
 *
 * The hub declares `settings.heat_pump_type` on its `heat_pump` class; a device
 * saved before that keeps its kind in its icon and name, which `heatPumpKindOf`
 * still reads.
 */
import { heatPumpKindOf } from '../../devices/deviceWidgetTypes';
import { variantFromSetting, variantValues, type VariantFamily } from './types';

export const HEAT_PUMP_VARIANTS: VariantFamily = {
  drawing: 'heat_pump',
  settingKey: 'heat_pump_type',
  title: ['Heat pump type', 'Vrsta toplotne črpalke'],
  description: [
    'Where this heat pump takes its heat from. The tile draws it; the controls stay.',
    'Od kod ta toplotna črpalka jemlje toploto. Ploščica to nariše; upravljanje ostane.',
  ],
  options: [
    { value: 'auto', icon: 'settings_suggest', label: ['Automatic', 'Samodejno'] },
    { value: 'air_water', icon: 'ac_unit', label: ['Air-to-water', 'Zrak–voda'] },
    { value: 'ground', icon: 'landscape', label: ['Ground-source (brine)', 'Zemlja–voda (slanica)'] },
    { value: 'water', icon: 'water', label: ['Water-source', 'Voda–voda'] },
    { value: 'air_air', icon: 'air', label: ['Air-to-air', 'Zrak–zrak'] },
    { value: 'exhaust', icon: 'wind_power', label: ['Exhaust-air', 'Odpadni zrak'] },
    { value: 'dhw', icon: 'water_heater', label: ['Hot water (DHW)', 'Sanitarna voda'] },
    { value: 'pool', icon: 'pool', label: ['Pool heat pump', 'Bazenska črpalka'] },
    { value: 'hybrid', icon: 'heat_pump', label: ['Hybrid (with boiler)', 'Hibrid (s kotlom)'] },
  ],
  defaultValue: 'auto',
  resolve: (device) =>
    variantFromSetting(device.settings, 'heat_pump_type', variantValues(HEAT_PUMP_VARIANTS)) ?? heatPumpKindOf(device),
};
